<template>
  <div class="premium-feature-route">
    <v-container v-if="loading" fluid class="premium-feature-route__state">
      <v-progress-circular indeterminate color="primary" size="38" />
      <span>{{ $t("premium.access.loading") }}</span>
    </v-container>

    <v-container v-else-if="errorMessage" fluid class="premium-feature-route__state">
      <v-alert type="error" class="premium-feature-route__error">
        {{ errorMessage }}
      </v-alert>
      <v-btn color="primary" variant="tonal" @click="loadAccess">
        <v-icon start>mdi-reload</v-icon>
        {{ $t("premium.access.retry") }}
      </v-btn>
    </v-container>

    <component
      :is="targetComponent"
      v-else-if="featureAccess.allowed && targetComponent"
      v-bind="$route.params"
    />

    <PremiumLockedPage v-else :feature-key="featureKey" />
  </div>
</template>

<script>
import AiWorkspace from "@/components/ai/AiWorkspace.vue";
import NcrmDataIntegrations from "@/components/ncrm/integrations/NcrmDataIntegrations.vue";
import NcrmImportDetails from "@/components/ncrm/integrations/NcrmImportDetails.vue";
import NcrmWorkflowsHome from "@/components/ncrm/workflows/NcrmWorkflowsHome.vue";
import NcrmWorkflowDetailsPage from "@/components/ncrm/workflows/NcrmWorkflowDetailsPage.vue";
import NcrmEmailMarketingWorkspace from "@/components/ncrm/email-marketing/NcrmEmailMarketingWorkspace.vue";
import {
  fetchPlatformAccess,
  resolveFeatureAccess,
  resolvePremiumFeatureForRoute,
} from "@/Utile/premiumAccess.mjs";
import PremiumLockedPage from "./PremiumLockedPage.vue";

const ROUTE_COMPONENTS = Object.freeze({
  AiWorkspace,
  NcrmDataIntegrations,
  NcrmImportDetails,
  NcrmEmailMarketing: NcrmEmailMarketingWorkspace,
  NcrmWorkflowsHome,
  NcrmWorkflowDetails: NcrmWorkflowDetailsPage,
});

export default {
  name: "PremiumFeatureRoute",
  components: { PremiumLockedPage },
  data() {
    return {
      loading: true,
      errorMessage: "",
      accessSnapshot: null,
    };
  },
  computed: {
    featureKey() {
      return resolvePremiumFeatureForRoute(this.$route?.name);
    },
    featureAccess() {
      return resolveFeatureAccess(this.accessSnapshot, this.featureKey);
    },
    targetComponent() {
      return ROUTE_COMPONENTS[this.$route?.name] || null;
    },
  },
  watch: {
    "$route.name": "loadAccess",
  },
  mounted() {
    this.loadAccess();
  },
  methods: {
    async loadAccess() {
      this.loading = true;
      this.errorMessage = "";
      try {
        const { data } = await fetchPlatformAccess();
        this.accessSnapshot = data || null;
      } catch (error) {
        this.accessSnapshot = null;
        this.errorMessage = error?.response?.data?.message || this.$t("premium.access.error");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.premium-feature-route {
  min-height: 100%;
}

.premium-feature-route__state {
  display: grid;
  place-items: center;
  align-content: center;
  gap: 16px;
  min-height: 55vh;
  color: var(--app-text-default);
  background: var(--app-page-background);
}

.premium-feature-route__error {
  width: min(100%, 620px);
}
</style>
